export var Type = {
  Text: 'text',
  Password: 'password'
};